import { Compass, Landmark, MapPin, Music, ShoppingBag, Utensils, Wrench, Heart } from "lucide-react";

/** @type {Array<[RegExp, import("lucide-react").LucideIcon]>} */
const RULES = [
  [/eat|drink|food|restaurant|café|cafe|bakery|coffee|brew|grill|kitchen|dining|sandwich|pizza|taco|cuisine|juice|sushi|japanese|mexican|bbq|barbecue|vegetarian|vegan|tapas|criollo|creole|puerto rican|deli|brunch|\bbar\b|\bbars\b/, Utensils],
  [/culture|museum|gallery|\bart\b|heritage|landmark|historic|cathedral|church|fort|plaza|theat|distiller|rum|sculpture|monument|promenade|waterfront|\bpark\b|garden|science|arena|entertainment|nature/, Landmark],
  [/experience|tour|boat|kayak|sail|beach|snorkel|dive|adventure|hike|rainforest|water/, Compass],
  [/nightlife|club|lounge|cocktail|salsa|music|dance|karaoke/, Music],
  [/shop|store|boutique|market|book|artisan|jewel|craft|souvenir|botánica|botanica/, ShoppingBag],
  [/lgbtq|gay|queer/, Heart],
  [/service|salon|barber|spa|gym|fitness|repair|tailor|cowork|studio/, Wrench],
];

export default function CategoryGlyph({ item, className }) {
  const hay = `${item?.label || ""} ${item?.title || ""} ${item?.type || ""}`.toLowerCase();
  const Icon = RULES.find(([pattern]) => pattern.test(hay))?.[1] || MapPin;
  return <Icon className={className} />;
}
